import { render, staticRenderFns } from "./cashBack.vue?vue&type=template&id=286abda1&scoped=true"
import script from "./cashBack.vue?vue&type=script&lang=js"
export * from "./cashBack.vue?vue&type=script&lang=js"
import style0 from "./cashBack.vue?vue&type=style&index=0&id=286abda1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286abda1",
  null
  
)

export default component.exports